export enum ECustomFormEntityName {
    menuSettings = 'administration.setting.model-role.menu'
}
